var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sys-input" },
    [
      _vm.inputType === "text"
        ? _c("a-input", {
            ref: "input",
            style: { width: _vm.width },
            on: { blur: _vm.closeInput },
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "inputValue"
            }
          })
        : _vm.inputType === "number"
        ? _c("a-input-number", {
            ref: "input",
            style: { width: _vm.width },
            attrs: { min: 0 },
            on: { blur: _vm.closeInput },
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "inputValue"
            }
          })
        : _c(
            "div",
            {
              staticClass: "input-text",
              style: { width: _vm.width },
              on: { click: _vm.editInput }
            },
            [_vm._v(_vm._s(_vm.inputValue))]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06c07e24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c07e24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Basic/sysInput.vue
// module id = hiYF
// module chunks = 125